/**
 * If enabled, disables FD relationship creation on page load from the backend
 */
export const ENABLE_UPDATED_FAIRE_DIRECT_RELATIONSHIP_CREATION_FLOW_240809 = 'ENABLE_UPDATED_FAIRE_DIRECT_RELATIONSHIP_CREATION_FLOW_240809';
